import {
  CategoryInfo,
  GetTablesTaggingStatusResponse,
} from "@/apis/workbook/types";
import { cn } from "@/lib/utils";
import { isCategoryTagged } from "./utils";

export const CategoryIndexItem = ({
  label,
  isTagged,
  onClick,
  className,
}: {
  label: string;
  isTagged: boolean;
  onClick: (e: React.MouseEvent<HTMLDivElement>) => void;
  className?: string;
}) => {
  return (
    <div
      className={cn(
        "inline-flex w-fit overflow-hidden p-0.5 px-1 items-center gap-2 text-neutral-500 hover:bg-neutral-100 active:bg-neutral-200 rounded-sm cursor-pointer hover:underline underline-offset-2",
        className,
      )}
      onClick={onClick}
    >
      <span className="label-1-normal-medium max-w-96 truncate">{label}</span>
      {isTagged && (
        <div className="flex w-1.5 h-1.5 justify-center items-center gap-[5.7px] rounded-full bg-green-400" />
      )}
    </div>
  );
};

const CategoryIndexSection = ({
  categories,
  taggingStatusData,
}: {
  categories: CategoryInfo[];
  taggingStatusData?: GetTablesTaggingStatusResponse;
}) => {
  return (
    <div className="flex max-w-[1440px] min-w-[1280px] mx-auto p-6 flex-col items-start gap-1.5 self-stretch bg-white">
      <div className="inline-flex p-0.5 justify-center items-center gap-2 text-neutral-500">
        <span className="label-1-normal-medium">목차</span>
      </div>
      {categories.map((category) => (
        <div
          key={category.id}
          className="flex flex-col items-start gap-1.5 self-stretch"
          onClick={() => {
            console.warn("Should be implemented");
          }}
        >
          <CategoryIndexItem
            label={category.category}
            isTagged={isCategoryTagged(category, taggingStatusData)}
            onClick={() => {
              const element = document.getElementById(category.id);
              if (element) {
                element.scrollIntoView({ behavior: "smooth" });
              } else {
                console.error(`Element with id ${category.id} not found`);
              }
            }}
          />
        </div>
      ))}
    </div>
  );
};

export default CategoryIndexSection;
